// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cleaningFormId } from './CleaningForm';
import { operatorId } from './Operator';
import { z } from 'zod';
export const cleaningFormSectionId = (z.number());
export const cleaningFormSection = z.object({
    id: cleaningFormSectionId,
    form_id: cleaningFormId,
    name: z.string(),
    description: z.string().nullable(),
    display_order: z.number(),
    is_collapsible: z.boolean(),
    is_collapsed_default: z.boolean(),
    created_at: z.date(),
    updated_at: z.date(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const cleaningFormSectionInitializer = z.object({
    id: cleaningFormSectionId.optional(),
    form_id: cleaningFormId,
    name: z.string(),
    description: z.string().optional().nullable(),
    display_order: z.number().optional(),
    is_collapsible: z.boolean().optional(),
    is_collapsed_default: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const cleaningFormSectionMutator = z.object({
    id: cleaningFormSectionId.optional(),
    form_id: cleaningFormId.optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    display_order: z.number().optional(),
    is_collapsible: z.boolean().optional(),
    is_collapsed_default: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=CleaningFormSection.js.map